import CaseStudy from "../../components/casestudy/CaseStudy";
import FleetTop from "../../assets/casestudy/images/FleetTop.jpg";
import FleetMid from "../../assets/casestudy/images/FleetMid.jpg";
import AgriTop from "../../assets/casestudy/images/AgriTop.jpg";
import {
  Achievement,
  Errors,
  Automated,
  Dashboards,
  Fleet,
  Time,
} from "../../controller/Images";

function CaseStudyOne() {
  const mockProps = {
    tagLabel: "CASE STUDY",
    pageTitle: "Driving Revenue Through Intelligent Fleet Automation",
    bannerImage: FleetTop,

    clientStory:
      "The client is a well-established ride-hailing operator in Singapore managing a sizeable fleet of vehicles. They had already implemented a comprehensive fleet management system across web and mobile platforms, supporting essential functions such as cab and driver master data, driver check-in/check-out, vehicle damage capture, and role-based access control.",
    title: "Key Details",
    details: [
      { label: "Domain", value: "Fleet Management & Transportation Systems" },
      { label: "Industry", value: "Urban Mobility Services" },
      {
        label: "Service Type",
        value: "Custom Application Development & Business Process Automation",
      },
      {
        label: "Engagement Model",
        value: "MVP-led Custom Development",
      },
      {
        label: "Technology Focus",
        value:
          "Rule-based Automation Engine, Compliance-aware Workflow Orchestration, Web & Mobile – Native iOS & Android Application Enhancement ,API-led Integration with Existing Fleet Systems",
      },
    ],
    businessChallenge: [
      "Despite this strong digital foundation, one of the most critical operational workflows - driver roster planning was still handled manually. Fleet managers relied heavily on Excel spreadsheets to allocate drivers to vehicles on a daily and weekly basis. This required balancing multiple variables, including driver time-offs, weekly offs, public holidays, vehicle availability, driver performance, and mandatory driver rest and leave requirements as per Singapore government regulations.",
      "As operations scaled, this manual approach became time-consuming, error-prone, and difficult to manage consistently. Ensuring regulatory compliance demanded significant manual effort, while the absence of real-time MIS and management dashboards delayed decision-making and impacted fleet utilization and revenue optimization.",
    ],

    midImage: FleetMid,
    solutions:
      "After evaluating multiple vendors and off-the-shelf products, the client found that existing solutions were either too generic, costly, or unable to integrate seamlessly with their existing systems while supporting complex business and statutory rules.",

    solutionsIntro: `After evaluating multiple vendors and off-the-shelf products, the client found that existing solutions were either too generic, costly, or unable to integrate seamlessly with their existing systems while supporting complex business and statutory rules.

BCPL proposed a custom-built, compliance-first automation solution that enhanced the client’s existing web and mobile ecosystem without disruption. The engagement began with a Minimum Viable Product (MVP) focused on an intelligent, rule-based driver rostering engine and was later expanded into a full-scale production solution.`,

    solutionsSubheading: "The BCPL solution enabled:",

    solutionPoints: [
      "Automated weekly driver roster generation using a configurable rule engine",
      "Built-in enforcement of driver rest periods, leave entitlements, and working hour limits aligned with Singapore government regulations",
      "Automated driver-to-vehicle allocation based on operational, business, and statutory constraints",
      "A mobile-first interface allowing drivers to view assigned shifts, vehicles, and rest days in real time",
      "Centralized data collation to deliver real-time MIS and actionable management insights",
    ],

    solutionsOutro:
      "This approach eliminated manual dependencies while improving accuracy, transparency, and compliance.",

    roiIntroLine1:
      "The solution delivered clear and measurable business value:",

    roiIntroLine2:
      "Key improvements were achieved across planning efficiency, operational accuracy, and regulatory compliance.",
    roiItems: [
      {
        icon: Time,
        percent: "~70%",
        title: "Reduction in Planning Time",
        description:
          "Weekly roster planning reduced from 15+ hours to just 4–5 hours, freeing up management time for strategic initiatives.",
      },
      {
        icon: Errors,
        percent: "95%+",
        title: "Reduction in Allocation Errors",
        description:
          "Manual allocation errors virtually eliminated from 20+ errors per month to less than 1, ensuring smooth operations and happier customers.",
      },
      {
        icon: Automated,
        percent: "100%",
        title: "Automated Compliance",
        description:
          "Complete automation of driver rest periods, working hours, and leave regulations eliminating compliance violations and regulatory risks.",
      },

      /* items WITHOUT percent */
      {
        icon: Dashboards,
        title: "MIS Dashboards & Faster Decisions",
        description:
          "Executive dashboards providing instant visibility into operations, enabling faster, data-driven decision-making and proactive management.",
      },
      {
        icon: Achievement,
        title: "Driver Satisfaction",
        description:
          "Transparent, mobile-accessible rosters with self-service capabilities dramatically improved driver satisfaction and reduced turnover.",
      },
      {
        icon: Fleet,
        title: "Fleet Utilization & Revenue Growth",
        description:
          "Optimized driver-vehicle-route matching increased fleet utilization by 15%, directly contributing to revenue growth and profitability.",
      },
    ],

    takeawayText:
      "By automating a mission-critical workflow and embedding regulatory compliance into the core of the solution, BCPL enabled the client to scale operations efficiently while reducing operational risk. This success story underscores BCPL's ability to deliver intelligent, scalable digital solutions that translate technology investments into measurable business outcomes.",

    cta: {
      title: "Unlock Growth with Bharat Clouds",
      description:
        "Looking to automate complex workflows, ensure regulatory compliance, or modernize your digital platforms? BCPL partners with organizations across web and mobile application development, cloud infrastructure, open-source ERP solutions, and staffing services to deliver scalable, business-driven technology solutions.",
      button: {
        text: "Talk To Us",
        link: "/lets-talk",
        variant: "primary",
      },
    },

    readingTitle: "Driving Revenue Through Intelligent Fleet Automation",

    socialLinks: {
      linkedin: "https://linkedin.com/company/bharatcloud",
      twitter: "https://twitter.com/bharatcloud",
      facebook: "https://facebook.com/bharatcloud",
      share: "#share",
    },

    recommendations: [
      {
        image: AgriTop,
        title:
          "Ensuring Stability in Agritech SaaS: Leadership Transition Without Disruption",
        link: "/case-studies/agritech-saas-leadership-transition-stability",
      },
      // {
      //   image:
      //     "https://images.unsplash.com/photo-1551434678-e076c223a692?ixlib=rb-4.0.3&auto=format&fit=crop&w=100&q=80",
      //   title: "AI-Powered Supply Chain Optimization",
      //   link: "/case-study/supply-chain",
      // },
      // {
      //   image:
      //     "https://images.unsplash.com/photo-1531973576160-7125cd663d86?ixlib=rb-4.0.3&auto=format&fit=crop&w=100&q=80",
      //   title: "Cloud Migration Success Story",
      //   link: "/case-study/cloud-migration",
      // },
    ],
  };

  return <CaseStudy {...mockProps} />;
}

export default CaseStudyOne;
